module.exports = __webpack_public_path__ + "static/img/fluoro.4d89c359.png";